import { useStyletron } from 'baseui'
import BackToSearchButton from '@/containers/SubscriptionFormPageNew/Components/shared/MeterSearch/BackToSearchButton'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { PulseResultsMessage, PulseResultsTitle, SearchModalBody, SearchModalFooter } from './styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'

const SearchResultsModal = ({ 
  title, 
  message, 
  isError = false, 
  onBackToSearch,
  backButtonText,
  children 
}) => {
  const [css] = useStyletron()
  const isPulse = usePulseScope()

  const modalBodyStyle = {
    padding: '0 32px',
    textAlign: 'center',
    ...(isError && { color: '#d44333' }),
  }

  if (isPulse) {
    return (
      <>
        <SearchModalBody $pulse>
          <PulseResultsMessage>
            <PulseResultsTitle>{title}</PulseResultsTitle>
            {message && !isError && <p>{message}</p>}
            {children}
          </PulseResultsMessage>
          <SDNotification hidden={!isError || !message} type='error' primaryText={message} />
        </SearchModalBody>
        <SearchModalFooter $pulse $alignStart>
          <BackToSearchButton onClick={onBackToSearch} text={backButtonText} />
        </SearchModalFooter>
      </>
    )
  }

  return (
    <>
      <SearchModalBody>
        <div className={css(modalBodyStyle)}>
          <h3>{title}</h3>
          {message && <p>{message}</p>}
          {children}
        </div>
      </SearchModalBody>
      <SearchModalFooter>
        <BackToSearchButton onClick={onBackToSearch} text={backButtonText} />
      </SearchModalFooter>
    </>
  )
}

export default SearchResultsModal
